import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HotelBuilding } from '../models/building.model';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingService {

  buildings: HotelBuilding[] = [];
  building: HotelBuilding;

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
  ) { }

  getBuildings(): Promise<HotelBuilding[]> {
    return new Promise((resolve, reject) => {
      this.http.get<HotelBuilding[]>(environment.apiURL + '/buildings').subscribe(
        (data) => {
          this.buildings = data.sort((a, b) => a.order - b.order);
          resolve(this.buildings);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  getBuilding(id: number): Promise<HotelBuilding> {
    return new Promise((resolve, reject) => {
      this.http.get<HotelBuilding>(environment.apiURL + '/building/' + id).subscribe(
        (data) => {
          this.building = data;
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  addBuilding(building: HotelBuilding): Promise<HotelBuilding> {
    return new Promise((resolve, reject) => {
      this.http.post<HotelBuilding>(environment.apiURL + '/building', building).subscribe(
        (data) => {
          this.getBuildings();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  updateBuilding(building: HotelBuilding): Promise<HotelBuilding> {
    return new Promise((resolve, reject) => {
      this.http.put<HotelBuilding>(environment.apiURL + '/building/' + building.id, building).subscribe(
        (data) => {
          this.getBuildings();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }

  deleteBuilding(id: number): Promise<HotelBuilding> {
    return new Promise((resolve, reject) => {
      this.http.delete<HotelBuilding>(environment.apiURL + '/building/' + id).subscribe(
        (data) => {
          this.getBuildings();
          resolve(data);
        },
        (err) => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(error);
        }
      );
    });
  }
}
